import React, { useMemo, useContext, useEffect, useState } from 'react'
import { Form } from 'react-final-form'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { AppLoader, EndUserContext } from '@portal/kit/pkg/components'

import paymentServices, { offerPaths, redirectToPayment } from 'helpers/payment-services'

import AuthenticationForm from './authentication-form'
import { PaymentContext } from 'components/providers/payment'
import checkoutValidator from './checkout-validator'

import SelectedOffer from '../offer-detail/selected-offer'
import OffersBreadcrumb from '../breadcrumb/breadcrumb-view'

export default function Authentication() {
  const { isStripe, catalogs, selectedCatalog, selectedOffer, getOffer } = useContext(PaymentContext)
  const [globalError, setGlobalError] = useState(null)
  const { t } = useTranslation()
  const { offerId } = useParams()
  const { data: user } = useContext(EndUserContext)

  useEffect(() => {
    getOffer(offerId)
  }, [offerId, getOffer])

  const initialValues = useMemo(() => {
    if (!user) return

    const { email, properties: { first_name, last_name } } = user
    return { email, first_name, last_name }
  }, [user])


  const goPay = async (values) => {
    try {
      const { createOrder } = paymentServices(isStripe)
      const paths = offerPaths(offerId)
      // Stripe : la confirmation arrive par webhook, on attend donc sur
      // ConfirmationInProgress que la commande ne soit plus "pending"
      const response = isStripe
        ? await createOrder(null, offerId, paths.confirmationInProgress, {
          cancel_path: paths.checkout,
          end_user: values,
        })
        : await createOrder(null, offerId, paths.confirmation, {
          end_user: values,
        })

      redirectToPayment(isStripe, response.data)
    }
    catch (e) {
      handleOrderErrors(e)
    }
  }

  const handleOrderErrors = (e) => {
    if (e.response && e.response.data && e.response.data.error) {
      setGlobalError(e.response.data.error.message)
    }
    else {
      setGlobalError(t('form.error'))
    }
  }

  if (!catalogs || !selectedOffer || !selectedCatalog || !user) return <AppLoader />

  return (
    <>
      <OffersBreadcrumb step="authentication" />
      <SelectedOffer offer={selectedOffer} isDetailed={false} />
      <Form
        initialValues={initialValues}
        onSubmit={goPay}
        validate={(values) => checkoutValidator(values)}
        render={formProps => <AuthenticationForm {...formProps} />}
        offer={selectedOffer}
        globalError={globalError}
      />
    </>
  )
}
